import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { marked } from 'marked';
import PageBasicTemplate from './PageBasicTemplate';
import { useCms, CmsStatus, HtmlContent, formatDate } from './redesign/Cms';
import Arrow from './redesign/Arrow';
type NewsItem = { title: string; published_date: string; updated_date?: string; category: string; content: string };
export default function NewsArticle() {
  const { id } = useParams();
  const { data, loading, error, retry } = useCms<NewsItem>(`/news-items/${encodeURIComponent(id || '')}`);
  const [html, setHtml] = useState('');
  useEffect(() => { if (data?.title) document.title = `${data.title} | 株式会社FRiCTON`; }, [data?.title]);
  useEffect(() => {
    let active = true; setHtml('');
    if (data?.content) Promise.resolve(marked.parse(data.content)).then(value => { if (active) setHtml(value); });
    return () => { active = false; };
  }, [data]);
  return <PageBasicTemplate title={data?.title || 'お知らせ'} sub_title={data?.category || 'FRiCTONからの最新情報'}>
    {loading || error || !data ? <CmsStatus loading={loading} error={error} retry={retry} empty="お探しの記事は現在表示できません。" /> : <><div className="article-meta"><time dateTime={data.published_date}>公開日 {formatDate(data.published_date)}</time>{data.updated_date && <time dateTime={data.updated_date}>更新日 {formatDate(data.updated_date)}</time>}</div><HtmlContent html={html} /></>}
    <Link to="/news" className="text-link" style={{ marginTop: 45 }}>お知らせ一覧へ <Arrow /></Link>
  </PageBasicTemplate>;
}
